import styled from "styled-components";

interface InviteButtonProps {
  spanText: string;
  icon?: any;
  CustomButtonClick: () => void;
}

const InviteButton = ({
  spanText,
  icon,
  CustomButtonClick = () => {},
}: InviteButtonProps) => {
  return (
    <InviteButtonContainer onClick={CustomButtonClick}>
      <span>{spanText}</span>
      {icon}
    </InviteButtonContainer>
  );
};

export default InviteButton;

const InviteButtonContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #000;
  color: #fff;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 20px;
  width: fit-content;
  &:hover {
    opacity: 0.9;
    box-shadow: 1px 5px 5px #0000004b;
  }
  span {
    font-size: 12px;
    text-transform: capitalize;
  }
`;
